import HowItWorks from "@/components/home/HowItWorks";
import NotFound from "@/components/common/NotFound";
import { isProspect } from "@/utils/type";

const HowItWorksPage = ({ type }) => {
    return isProspect(type) ? <HowItWorks /> : <NotFound />;
};

export async function getStaticProps() {
    return { props: { type: process.env.NEXT_PUBLIC_TYPE } };
}

export default HowItWorksPage;
